import * as React from 'react';
import {ClientBrowsingHistory} from "../../../../domain/model/client_browsing_history";
import {Customer} from "../../../../domain/model/customer";
import PageWrapper from "../../../common/atom/wrapper/page_wrapper";
import ClientClientBrowsingHistoriesMain from "./client_browsing_histories_main";
import Progress from "../../../common/organism/progress";
import {TJobCareerWithCustomerID} from "../../../../domain/repository/job_career_repository";
import EmptyData from "../../../common/organism/empty_data";
import {ClientBrowsingHistoriesEmpty} from "../../../../config/view_const/client_browsing_histories";
import {TBreadcrumbItem, TPagination} from '../../../type/common';
import {routeConfig} from "../../../../config/language/ja-JP/presentation/route_text";
import Breadcrumbs from "../../../common/molecular/breadcrumbs/breadcrumbs";
import {ClientBookmark} from "../../../../domain/model/client_bookmark";

interface IProps {
    isInit: boolean;
    clientBrowsingHistories: ClientBrowsingHistory[];
    customers: Customer[];
    jobCareersWithCustomerID: TJobCareerWithCustomerID[],
    clientBookmarks: ClientBookmark[],
    isLoading: boolean;
    paginationPrams: TPagination
}

const ClientClientBrowsingHistoriesComponent: React.FC<IProps> = (props) => {

    const {isInit, clientBrowsingHistories, customers, jobCareersWithCustomerID, clientBookmarks, isLoading, paginationPrams} = props;

    // 初期化
    if (isInit) { return <Progress canAnimation={false}/>}

    const breadcrumbItems: TBreadcrumbItem[] = [
        routeConfig.clientRoot,
        routeConfig.clientBrowsingHistories
    ]

    const res: JSX.Element = (
        <React.Fragment>
            {isLoading && <Progress canAnimation={false}/>}
            <PageWrapper>
                <Breadcrumbs breadcrumbItems={breadcrumbItems} />

                { clientBrowsingHistories.length === 0 &&
                <EmptyData
                    main={ClientBrowsingHistoriesEmpty.clientBrowsingHistoriesForClientMain}
                    description={ClientBrowsingHistoriesEmpty.clientBrowsingHistoriesForClientDescription}
                />
                }
                { clientBrowsingHistories.length > 0 &&
                <ClientClientBrowsingHistoriesMain
                    clientBrowsingHistories={clientBrowsingHistories}
                    customers={customers}
                    jobCareersWithCustomerID={jobCareersWithCustomerID}
                    clientBookmarks={clientBookmarks}
                    paginationPrams={paginationPrams}
                />
                }
            </PageWrapper>
        </React.Fragment>

    );

    return (res);

};

export default ClientClientBrowsingHistoriesComponent;



// WEBPACK FOOTER //
// ./src/presentation/component/client/client_browsing_histories/client_browsing_histories.tsx